import styled, { css } from "styled-components";

export const InputContainer = styled.div`
  ${({ customCss }) => css`
    ${customCss}
  `}
`;

export const CustomForm = styled.form`
  display: flex;
  align-items: center;
  max-width: 100%;
  position: relative;

  ${({
    isAutocomplete,
    isFocused,
    bgColor,
    borderConfig,
    borderRadius,
    fontColor,
    fontSize,
    height,
    width,
  }) => `
    width: ${width ?? "557px"};
    height: ${height ?? "44px"};
    box-sizing: border-box;

    font-size: ${fontSize ?? "13.12px"};
    color: ${fontColor ?? "#797777"};
    background-color: ${bgColor ?? "rgb(255, 255, 255)"};

    border: ${borderConfig ?? "1px solid rgba(0, 0, 0, 0.1)"};
    border-radius: ${borderRadius ?? "18px"};

    border-bottom-right-radius: ${
      isAutocomplete && isFocused ? "0" : borderRadius ?? "18px"
    };

    border-bottom-left-radius: ${
      isAutocomplete && isFocused ? "0" : borderRadius ?? "18px"
    };

    padding: 15px;
  `}
`;

export const CustomInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  padding-left: 10px;

  ${({ bgColor, fontColor }) => `
    color: ${fontColor ?? "#797777"};
    background-color: ${bgColor ?? "rgb(255, 255, 255)"};
  `}
`;

export const CustomSearchIcon = styled.button`
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  min-width: 1.25rem;
  margin: 0;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  padding: 0;
  border: none;
  background: transparent;

  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;

  ${({ iconColor, iconSize }) => `
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg fill='${
      encodeURIComponent(iconColor) || "currentColor"
    }' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' width='50px' height='50px'%3e%3cpath d='M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z'/%3e%3c/svg%3e");

    width: ${iconSize ?? "25px"};
    height: ${iconSize ?? "25px"};
    color: ${iconColor ?? "rgb(0, 0, 0)"};
  `}
`;

export const CustomClearIcon = styled.div`
  border: none;
  background: transparent;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg focusable='false' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'%3e%3c/path%3e%3c/svg%3e");
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  width: 22px;
  height: 22px;
  min-width: 22px;
  min-height: 22px;
  margin: 0 20px;
  transition: all 0.3s;
  @media only screen and (max-width: 700px) {
    margin: 0 10px;
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
  }
`;
